import React from 'react';
import lauram from '../assets/paula2.png'
import juanp from '../assets/camilo2.jpg'
const testimonialsData = [
  {
    name: "Juan P, Recursos Humanos",
    opinion: "Desde que usamos SimVR, redujimos el tiempo de inducción en un 40%",
    image: juanp
  },
  {
    name: "Laura M., Jefe de Planta",
    opinion: "Perfecto para capacitar en procesos de riesgo sin exponer a nadie",
    image: lauram
  }
];

function Testimonials() {
  return (
    <div className="container testimonials">
      <h2 className='section-title'>Testimonios</h2>
      <div className="testimonial-list row">
        {testimonialsData.map((testimonial, index) => (
          
          <div key={index} className="testimonial-item col-12 col-md-6 mb-4 d-flex align-items-center">
            <div className='testimonial-image me3'>
              <img src={testimonial.image} alt="foto_testimonio"  style={{width: "150px", height: "150px", borderRadius: "50%", objectFit: "cover", borderStyle:'solid'}}/>
          </div>
           <div className='testimonial'>
            <p>"{testimonial.opinion}"</p>
            <p>-- {testimonial.name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Testimonials;